import { HomeEvents } from "@/home/home-events";

/** HP / MP passive regen multiplier while sit-rest is active. */
export const COMBAT_SIT_REST_REGEN_MULT = 2;

export function emitCombatSitRestChanged(enabled: boolean): void {
  window.dispatchEvent(
    new CustomEvent(HomeEvents.SitRestChanged, { detail: { enabled } }),
  );
}
